import { useCallback, useEffect } from "react";
import { getTabId } from "../constants/TabId";

export enum SessionEvent {
	START_LOGIN = "START_LOGIN",
	START_LOGOUT = "START_LOGOUT",
	LOGIN_COMPLETE = "LOGIN_COMPLETE",
	LOGOUT_COMPLETE = "LOGOUT_COMPLETE",
	NEWTAB = "NEWTAB",
	SESSION_UPDATE = "SESSION_UPDATE",
}

type SessionMessage = {
	tabId: string;
	timestamp: number | null;
	type: SessionEvent;
};

const channel = new BroadcastChannel(`PROCURACON_SESSION_CHANNEL`);

/**
 * Provides broadcasting over a single channel for session events (login/out/session timeout)
 * @param onEvent
 * @returns
 */
export const useSessionBroadcast = (onEvent: (msg: SessionMessage) => void) => {
	const sendSessionBroadcast = useCallback(
		(
			type: SessionEvent,
			timestamp: number | null = null,
			tabId: string = getTabId()
		) => {
			channel.postMessage({ type, timestamp, tabId });
		},
		[]
	);

	useEffect(() => {
		const handler = (e: MessageEvent) => onEvent(e.data);
		channel.addEventListener("message", handler);

		return () => {
			channel.removeEventListener("message", handler);
		};
	}, [onEvent]);

	return { sendSessionBroadcast };
};
